export default __webpack_public_path__ + "static/media/c001-student-1.bf18ee98.jpg";